export const volSurfaces = [
  '5C',
  '5FLY',
  '5P',
  '5RR',
  '10C',
  '10FLY',
  '10P',
  '10RR',
  '15C',
  '15FLY',
  '15P',
  '15RR',
  '20C',
  '20FLY',
  '20P',
  '20RR',
  '25C',
  '25FLY',
  '25P',
  '25RR',
  '30C',
  '30FLY',
  '30P',
  '30RR',
  '35C',
  '35FLY',
  '35P',
  '35RR',
  '40C',
  '40FLY',
  '40P',
  '40RR',
  'ATMF',
];
export const tenors = ['1W', '2W', '1M', '3M', '6M', '9M', '1Y'];
